import type { PeriodInfo } from "@core/period-info"
import { CURRENCY_SEPARATOR } from "@core/pricing"
import type { PriceType } from "@core/types"
import type { PriceData } from "@ionos-web-design-system/react"

export const getFirstPurchaseFreePriceData = (
  currentPriceType: PriceType,
  periodInfo: PeriodInfo
): PriceData | null => {
  if (!periodInfo.isFirstPurchaseFreePresentation()) {
    return null
  }

  const { priceValue } = periodInfo.getPrices(currentPriceType)

  const priceSuffix = periodInfo.periodText(false, true)

  return {
    main: {
      comma: CURRENCY_SEPARATOR,
      currencySymbolPosition: "after",
      decimalPrice: priceValue.split(CURRENCY_SEPARATOR)[1] || "00",
      integerPrice: priceValue.split(CURRENCY_SEPARATOR)[0],
      additionalInfo: priceSuffix,
    },
  }
}
